import { render, staticRenderFns } from "./SaleOrderView.vue?vue&type=template&id=2e69f1e6&scoped=true"
import script from "./SaleOrderView.vue?vue&type=script&lang=js"
export * from "./SaleOrderView.vue?vue&type=script&lang=js"
import style0 from "./SaleOrderView.vue?vue&type=style&index=0&id=2e69f1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e69f1e6",
  null
  
)

export default component.exports